// admin routes protected
import { Navigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import { useEffect, useState } from 'react';
import api from '../services/api';

const AdminRoute = ({ children }) => {
  const { user: clerkUser, isLoaded, isSignedIn } = useUser();
  const [userProfile, setUserProfile] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (!isLoaded) return;

      if (!isSignedIn) {
        setChecking(false);
        return;
      }

      try {
        const token = clerkUser && clerkUser.getToken ? await clerkUser.getToken() : null;
        const response = await api.get('/auth/profile', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (response?.user) {
          setUserProfile(response.user);
        }
      } catch (error) {
        console.error('Failed to fetch user profile:', error);
      } finally {
        setChecking(false);
      }
    };

    fetchUserProfile();
  }, [isLoaded, isSignedIn, clerkUser]);

  // Wait for Clerk to load and profile to be fetched
  if (!isLoaded || checking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isSignedIn) {
    return <Navigate to="/login" />;
  }

  // Check if user is admin (by email or role). If backend profile is missing
  // allow access when Clerk user email matches the superadmin email.
  const clerkEmail = clerkUser?.primaryEmailAddress?.emailAddress;
  const SUPERADMIN_EMAILS = ['info@africandebatechampions.org', 'africandebatechampions@gmail.com'];
  const isAdminByClerk = SUPERADMIN_EMAILS.includes(clerkEmail) || clerkUser?.publicMetadata?.role === 'admin';
  const isAdminByProfile = SUPERADMIN_EMAILS.includes(userProfile?.email) || userProfile?.role === 'admin';

  const isAdmin = isAdminByProfile || isAdminByClerk;

  if (!isAdmin) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default AdminRoute;